export default "__VITE_ASSET__BIZP6QGU__"